export const filetype = filename => {
  if (typeof filename !== "string") return false;
  const ext = filename.match(/\.[0-9a-z]+$/i);
  return ext && ext[0];
};
